import { Services } from '@smiles/voebiz-core-corporate-club';

export const verifyActiveFlag = async (memberNumVoeBiz: string) => {
  try {
    return (await Services.getParametersPurchaseMiles({ memberNumberVoeBiz: memberNumVoeBiz })).data?.active;
  } catch (error) {
    console.log(error);
    return null;
  }
};
